"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseWsTransport = void 0;
exports.decodeWsWireText = decodeWsWireText;
const emitter_1 = require("../emitter");
const utils_1 = require("../utils");
const constants_1 = require("./constants");
/** Декодирование сырого WS-сообщения (браузер / Node `ws`). */
function decodeWsWireText(data) {
    if (typeof data === 'string')
        return data;
    if (typeof Buffer !== 'undefined' && Buffer.isBuffer(data)) {
        return (0, utils_1.decodeFromWin1251)(data);
    }
    if (data instanceof ArrayBuffer) {
        return (0, utils_1.decodeFromWin1251)(new Uint8Array(data));
    }
    if (data instanceof Uint8Array) {
        return (0, utils_1.decodeFromWin1251)(data);
    }
    if (Array.isArray(data) && data.length > 0 && typeof Buffer !== 'undefined') {
        return (0, utils_1.decodeFromWin1251)(Buffer.concat(data));
    }
    return String(data);
}
/**
 * Общая логика WSS backup: pending map, JSON+win1251 decode, keep-alive `el`.
 * Подклассы отвечают за connect/send/upload.
 */
class BaseWsTransport extends emitter_1.UniversalEmitter {
    constructor() {
        super(...arguments);
        this.requestId = 1000;
        this.pendingRequests = new Map();
        this.keepAliveTimer = null;
        this.userId = 0;
    }
    allocateRequestId(override) {
        return override ?? this.requestId++;
    }
    trackPending(id, resolve, reject, timeoutMs, timeoutMessage) {
        const timeoutId = setTimeout(() => {
            if (!this.pendingRequests.has(id))
                return;
            this.pendingRequests.delete(id);
            reject(new Error(timeoutMessage));
        }, timeoutMs);
        this.pendingRequests.set(id, { resolve, reject, timeoutId });
    }
    failPending(id, error) {
        const pending = this.pendingRequests.get(id);
        if (!pending)
            return;
        clearTimeout(pending.timeoutId);
        this.pendingRequests.delete(id);
        pending.reject(error);
    }
    rejectAllPending(error) {
        for (const pending of this.pendingRequests.values()) {
            clearTimeout(pending.timeoutId);
            pending.reject(error);
        }
        this.pendingRequests.clear();
    }
    dispatchWireMessage(data, logLabel = 'WS') {
        const text = decodeWsWireText(data);
        if (!text)
            return;
        try {
            const msg = JSON.parse(text);
            if (!Array.isArray(msg))
                return;
            const [msgId, status, ...rest] = msg;
            if (msgId === 0) {
                this.emit('message', { id: msgId, status, data: rest });
                return;
            }
            const pending = this.pendingRequests.get(msgId);
            if (pending) {
                clearTimeout(pending.timeoutId);
                this.pendingRequests.delete(msgId);
                pending.resolve({
                    id: msgId,
                    status: status,
                    data: rest,
                });
            }
            else {
                this.emit('message', { id: msgId, status, data: rest });
            }
        }
        catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            this.emit('error', new Error(`${logLabel} parse error: ${message}`));
        }
    }
    buildKeepAlivePayload() {
        return (0, utils_1.encodePdaJson)([0, 'el', this.userId || 0]);
    }
    startKeepAlive(sendPayload) {
        this.stopKeepAlive();
        this.keepAliveTimer = setInterval(() => {
            if (!this.isConnected())
                return;
            try {
                sendPayload();
            }
            catch {
                // ignore keep-alive send errors
            }
        }, constants_1.KEEP_ALIVE_MS);
    }
    stopKeepAlive() {
        if (this.keepAliveTimer) {
            clearInterval(this.keepAliveTimer);
            this.keepAliveTimer = null;
        }
    }
}
exports.BaseWsTransport = BaseWsTransport;
